import dompurify from 'dompurify';

export const sanitizePaste = (paste: string): string => {
  const sanitisedPaste = dompurify.sanitize(paste, { ALLOWED_TAGS: [] });
  // The following regex removes any line breaks, empty paragraghs and excessive spaces
  // This is due to copying & pasting from apps like MS Word
  const filteredPaste = sanitisedPaste
    .replace(/\r?\n|\r|(<|&lt;)br\s*\/*(>|&gt;)|((<|&lt;)p(>|&gt;))?&nbsp;((<|&lt;)\/p(>|&gt;))?/g, '') //NOSONAR
    .trim();
  // Second sanitize is required to properly remove all tags after filtering the string
  return dompurify.sanitize(filteredPaste, { ALLOWED_TAGS: [] });
};

export const stripHTMLTags = (html: string) => {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return doc?.body?.textContent?.trim();
};
